/**
 * Portal version constant — displayed in the footer + sent as the
 * `X-PCB-Client-Version` header on every API call.
 *
 * Per the global CLAUDE.md versioning rule: bump this in lockstep with
 * `package.json` `version` and the `<meta name="portal-version">` tag.
 */
export const PORTAL_VERSION = '0.18.0';
export const PORTAL_NAME = 'PCB Retail';
export const PORTAL_CLIENT_ID = 'RCP-portal';
